export default __webpack_public_path__ + "static/media/DP Mushin Labs.e3b0f1fb.png";